module.exports = __webpack_public_path__ + "static/media/Photochemistry.a862909e.jpg";